import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Row } from "react-bootstrap";

import { FormattedMessage, useIntl } from "react-intl";
import { editSection, getSection } from "store/actions";
import Loader from "components/shared/Loader";
import { useState } from "react";

import SaveChangesButton from "components/shared/SaveChangesButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import SlidersArray from "./SliderArray";
const Faqs = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const { loading, error, section } = useSelector((state) => state.section);

  const [sliders, setSliders] = useState([]);
  const { reset, handleSubmit } = useForm();

  // get single page by slug
  useEffect(() => {
    dispatch(
      getSection({
        page: "faqs",
        slug: "faqs",
      })
    );
  }, [dispatch]);

  useEffect(() => {
    reset(section);
    setSliders(section?.items);
  }, [reset, section]);

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    data.items = sliders;
    dispatch(
      editSection({ slug: "faqs", page: "faqs", data: { section: data } })
    );
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"faqs"} />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Row>
                <SlidersArray sliders={sliders} setSliders={setSliders} />
              </Row>

              <SaveChangesButton />
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Faqs;
